var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"section-header-small"},[_c('div',{staticClass:"first-line"},[_vm._v(_vm._s(_vm.first))]),_c('h2',{staticClass:"second-line"},[_vm._v(_vm._s(_vm.second))])])
}
var staticRenderFns = []

export { render, staticRenderFns }